import { render, staticRenderFns } from "./preview-modal.vue?vue&type=template&id=4f8aaa16&scoped=true"
import script from "./preview-modal.vue?vue&type=script&lang=js"
export * from "./preview-modal.vue?vue&type=script&lang=js"
import style0 from "./preview-modal.vue?vue&type=style&index=0&id=4f8aaa16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8aaa16",
  null
  
)

export default component.exports